import { useState, useEffect, useCallback } from 'react';
import { SupplierSettingsApi } from '@/api/clients/supplier-settings/supplier-settings.api';

export const useGetSupplierSettings = (organizationId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = useCallback(async () => {
    if (!organizationId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await SupplierSettingsApi.getSettings(organizationId);
      setData(response.data);
    } catch (err) {
      setError(err);
      console.error('Failed to load supplier portal settings', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    data,
    loading,
    error,
    refetch: fetchSettings,
  };
};
